import Image from 'next/image'
import { useRouter } from 'next/router'

import { Button, Container, Typography } from '@cleartrip/ct-design-components'
import { RAVEN_ATTRIBUTE_NAME, RAVEN_PAGE_NAME } from '@/analytics/raven/ravenConstants'
import { ravenSDKTrigger } from '@/analytics/raven/ravenSDKHelper'
import { EXPLORE_GLOBE_ICON_URL } from '@/constants/explore'
import { getflightsHistory } from '@/utils/general/browserHelper'
import { getExploreRouteQuery } from '@/utils/explore'

import styles from './exploreAnywhere.module.scss'

const EXPLORE_DEFAULT_SOURCE = 'BLR'
const EXPLORE_MAP_PREVIEW_URL =
    'https://rukmini-ct.flixcart.com/q_auto/staticresource-prod/images/explore/map_viewer.png'

interface ExploreAnywhereMapProps {
    sourceCode?: string
    /** FHP depart date in DD/MM/YYYY — converted to YYYY-MM-DD for explore. */
    departDate?: string
}

function resolveExploreSource(sourceCode?: string): string {
    const trimmed = sourceCode?.trim().toUpperCase()
    if (trimmed && /^[A-Z]{3}$/.test(trimmed)) {
        return trimmed
    }

    const history = getflightsHistory()
    const fromHistory = history?.[0]?.from?.trim().toUpperCase()
    if (fromHistory && /^[A-Z]{3}$/.test(fromHistory)) {
        return fromHistory
    }

    return EXPLORE_DEFAULT_SOURCE
}

const ExploreAnywhereMap = ({ sourceCode, departDate }: ExploreAnywhereMapProps) => {
    const router = useRouter()

    function handleOpenMap() {
        ravenSDKTrigger('a_ui_action', {
            action_name: RAVEN_ATTRIBUTE_NAME.HP_EXPLORE_MAP_CLICK,
            action_type: 'click',
            page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME,
        })
        void router.push({
            pathname: '/flights/explore',
            query: getExploreRouteQuery({
                source: resolveExploreSource(sourceCode),
                departDate,
            }),
        })
    }

    return (
        <section className={`w-100p mt-6 ${styles.root}`} aria-label="Explore anywhere on map">
            <Typography variant="HM2" className="mb-4 c-neutral-900">
                Explore Anywhere
            </Typography>
            <Container className={'p-relative w-100p br-12 o-hidden ' + styles.mapCard}>
                <Image
                    alt="Map of Europe showing travel routes and destinations"
                    className={styles.mapImage}
                    fill
                    priority={false}
                    sizes="(max-width: 1200px) 100vw, 1200px"
                    src={EXPLORE_MAP_PREVIEW_URL}
                />
                <Container className={styles.openMapBtnWrapper}>
                    <Button
                        className={`flex flex-middle fs-16 fw-600 br-8 py-2 px-3  ${styles.openMapBtn}`}
                        color="neutral"
                        variant="contained"
                        onClick={handleOpenMap}
                        showLeftIcon
                        LeftIcon={
                            <img
                                alt=""
                                height={20}
                                width={20}
                                className={styles.globeIcon}
                                src={EXPLORE_GLOBE_ICON_URL}
                            />
                        }
                    >
                        Open map
                    </Button>
                </Container>
            </Container>
        </section>
    )
}

export default ExploreAnywhereMap
